export function commentPatchBody(comment) {
    return { comment };
}

export function settleNoteSave({ sent, storedComment, currentDraft }) {
    const stored = (storedComment || '').trim();
    if (stored !== sent) return { clean: false, status: 'error', resave: false };
    if ((currentDraft || '').trim() !== sent) return { clean: false, status: 'idle', resave: true };
    return { clean: true, status: 'saved', resave: false };
}
